import { marked } from 'marked';

marked.setOptions({
  gfm: true,
  breaks: true // 单个换行符也转换为 <br>，保留 AI 回复的段落格式
});

/** 将 Markdown 文本渲染为 HTML（用于智能客服 AI 回复内容展示） */
export function renderMarkdown(content: string): string {
  if (!content) return '';
  return marked.parse(content) as string;
}
